export let copyObject = (object) => {
  return JSON.parse(JSON.stringify(object));
};
